import { render, staticRenderFns } from "./visualizar.vue?vue&type=template&id=354cba34&scoped=true"
import script from "./visualizar.vue?vue&type=script&lang=js"
export * from "./visualizar.vue?vue&type=script&lang=js"
import style0 from "./visualizar.vue?vue&type=style&index=0&id=354cba34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354cba34",
  null
  
)

export default component.exports